import React, {FC, useEffect, useState} from 'react';

import { useStoreon } from 'storeon/react';
import { IEvents, IState } from 'src/store';

import styled, { css } from 'src/theme';

import { Switch, Select, Option } from "src/components/UI";

import { usePresenter } from './usePresenter';


const fenceAllColors = {
  picket: [
    {
      id: 1,
      colorName: 'RAL 1014',
      colorSecondName: 'слоновая кость',
      colorCode: '#ddc49a',
    },
    {
      id: 2,
      colorName: 'RAL 1015',
      colorSecondName: 'светлая слоновая кость',
      colorCode: '#e6d2b5',
    },
    {
      id: 3,
      colorName: 'RAL 1018',
      colorSecondName: 'цинково-желтый',
      colorCode: '#faca30',
    },
    {
      id: 4,
      colorName: 'RAL 2004',
      colorSecondName: 'оранжевый',
      colorCode: '#e25303',
    },
    {
      id: 5,
      colorName: 'RAL 3003',
      colorSecondName: 'рубиново-красный',
      colorCode: '#861a22',
    },
    {
      id: 6,
      colorName: 'RAL 3005',
      colorSecondName: 'винно-красный',
      colorCode: '#59191f',
    },
    {
      id: 7,
      colorName: 'RAL 3009',
      colorSecondName: 'оксид красный',
      colorCode: '#6d342d',
    },
    {
      id: 8,
      colorName: 'RAL 3011',
      colorSecondName: 'коричнево-красный',
      colorCode: '#792423',
    },
    {
      id: 9,
      colorName: 'RAL 3020',
      colorSecondName: 'транспортный красный',
      colorCode: '#bb1e10',
    },
    {
      id: 10,
      colorName: 'RAL 5002',
      colorSecondName: 'ультрамариново-синий',
      colorCode: '#00387b',
    },
    {
      id: 11,
      colorName: 'RAL 5005',
      colorSecondName: 'сигнальный синий',
      colorCode: '#005387',
    },
    {
      id: 12,
      colorName: 'RAL 5021',
      colorSecondName: 'водная синь',
      colorCode: '#007577',
    },
    {
      id: 13,
      colorName: 'RAL 6002',
      colorSecondName: 'лиственно-зеленый',
      colorCode: '#325928',
    },
    {
      id: 14,
      colorName: 'RAL 6005',
      colorSecondName: 'зеленый мох',
      colorCode: '#114232',
    },
    {
      id: 15,
      colorName: 'RAL 7004',
      colorSecondName: 'сигнальный серый',
      colorCode: '#9b9b9b',
    },
    {
      id: 16,
      colorName: 'RAL 7024',
      colorSecondName: 'графитовый серый',
      colorCode: '#45494e',
    },
    {
      id: 17,
      colorName: 'RAL 8017',
      colorSecondName: 'шоколадно-коричневый',
      colorCode: '#442f29',
    },
    {
      id: 18,
      colorName: 'RAL 9003',
      colorSecondName: 'сигнальный белый',
      colorCode: '#ecece7',
    },
    {
      id: 19,
      colorName: 'Белый камень',
      colorSecondName: 'Белый камень',
      colorCode: '#dbbfa3',
    },
    {
      id: 20,
      colorName: 'Кедр',
      colorSecondName: 'Кедр',
      colorCode: '#d9a180',
    },
    {
      id: 21,
      colorName: 'Золотой дуб',
      colorSecondName: 'Золотой дуб',
      colorCode: '#e0a376',
    },
    {
      id: 22,
      colorName: 'Мореный дуб',
      colorSecondName: 'Мореный дуб',
      colorCode: '#3e210f',
    },
    {
      id: 23,
      colorName: 'Сосна',
      colorSecondName: 'Сосна',
      colorCode: '#e5d09c',
    },
  ],
  pailing: [
    {
      id: 1,
      colorName: 'RAL 1014',
      colorSecondName: 'слоновая кость',
      colorCode: '#ddc49a',
    },
    {
      id: 2,
      colorName: 'RAL 1015',
      colorSecondName: 'светлая слоновая кость',
      colorCode: '#e6d2b5',
    },
    {
      id: 3,
      colorName: 'RAL 1035',
      colorSecondName: 'перламутрово-бежевый',
      colorCode: '#908370',
    },
    {
      id: 4,
      colorName: 'RAL 2004',
      colorSecondName: 'оранжевый',
      colorCode: '#e25303',
    },
    {
      id: 5,
      colorName: 'RAL 3003',
      colorSecondName: 'рубиново-красный',
      colorCode: '#861a22',
    },
    {
      id: 6,
      colorName: 'RAL 3005',
      colorSecondName: 'винно-красный',
      colorCode: '#59191f',
    },
    {
      id: 7,
      colorName: 'RAL 3009',
      colorSecondName: 'оксид красный',
      colorCode: '#6d342d',
    },
    {
      id: 8,
      colorName: 'RAL 3011',
      colorSecondName: 'коричнево-красный',
      colorCode: '#792423',
    },
    {
      id: 9,
      colorName: 'RAL 3020',
      colorSecondName: 'транспортный красный',
      colorCode: '#bb1e10',
    },
    {
      id: 10,
      colorName: 'RAL 5002',
      colorSecondName: 'ультрамариново-синий',
      colorCode: '#00387b',
    },
    {
      id: 11,
      colorName: 'RAL 5005',
      colorSecondName: 'сигнальный синий',
      colorCode: '#005387',
    },
    {
      id: 12,
      colorName: 'RAL 5021',
      colorSecondName: 'водная синь',
      colorCode: '#007577',
    },
    {
      id: 13,
      colorName: 'RAL 6002',
      colorSecondName: 'лиственно-зеленый',
      colorCode: '#325928',
    },
    {
      id: 14,
      colorName: 'RAL 6005',
      colorSecondName: 'зеленый мох',
      colorCode: '#114232',
    },
    {
      id: 15,
      colorName: 'RAL 7004',
      colorSecondName: 'сигнальный серый',
      colorCode: '#9b9b9b',
    },
    {
      id: 16,
      colorName: 'RAL 7005',
      colorSecondName: 'мышино-серый',
      colorCode: '#6c6e6b',
    },
    {
      id: 17,
      colorName: 'RAL 7024',
      colorSecondName: 'графитовый серый',
      colorCode: '#45494e',
    },
    {
      id: 18,
      colorName: 'RAL 7035',
      colorSecondName: 'светло-серый',
      colorCode: '#c5c7c4',
    },
    {
      id: 19,
      colorName: 'RAL 8017',
      colorSecondName: 'шоколадно-коричневый',
      colorCode: '#442f29',
    },
    {
      id: 20,
      colorName: 'RAL 9002',
      colorSecondName: 'серо-белый',
      colorCode: '#d7d5cb',
    },
    {
      id: 21,
      colorName: 'RAL 9003',
      colorSecondName: 'сигнальный белый',
      colorCode: '#ecece7',
    },
    {
      id: 22,
      colorName: 'RAL 9006',
      colorSecondName: 'бело-алюминиевый',
      colorCode: '#a1a1a0',
    },
    {
      id: 23,
      colorName: 'RAL 9010',
      colorSecondName: 'белый',
      colorCode: '#f1ece1',
    },
    {
      id: 24,
      colorName: 'RR32',
      colorSecondName: 'темно-коричневый',
      colorCode: '#3d2a19',
    },
    {
      id: 25,
      colorName: 'RAL 6018',
      colorSecondName: 'желто-зеленый',
      colorCode: '#61993b',
    },
    {
      id: 26,
      colorName: 'RAL 6019',
      colorSecondName: 'бело-зеленый',
      colorCode: '#b9ceac',
    },
    {
      id: 27,
      colorName: 'RAL 8004',
      colorSecondName: 'медно-коричневый',
      colorCode: '#8d4931',
    },
    {
      id: 28,
      colorName: 'RAL 9005',
      colorSecondName: 'черный янтарь',
      colorCode: '#0e0e10',
    },
    {
      id: 29,
      colorName: 'Tourmalin',
      colorSecondName: 'Дымчато-зелёный металлик',
      colorCode: '#68875d',
    },
    {
      id: 30,
      colorName: 'Argillite',
      colorSecondName: 'Медный металлик',
      colorCode: '#ac6b4f',
    },
    {
      id: 31,
      colorName: 'Galmei',
      colorSecondName: 'Сиреневый металлик',
      colorCode: '#7b99b1',
    },
    {
      id: 32,
      colorName: 'Цинк',
      colorSecondName: 'Цинк',
      colorCode: '#a7a9ae',
    },
  ]
}






export const Image: FC = () => {
  const { dispatch, fenceStore } = useStoreon<IState, IEvents>('fenceStore');
  const presenter = usePresenter();

  const [colors, setColors] = useState(fenceAllColors.pailing)

  useEffect(() => {

    if (fenceStore.fenceType === 'picket') {
      const getPicketCoatingColor = () => {
        switch (fenceStore.picketCoating) {
          case 'Полиэстер 0,4 мм':
            return fenceAllColors.picket.filter(color => [1,6,11,14,15,17,18].includes(color.id));
          case 'Полиэстер 0,45 мм':
            return fenceAllColors.picket.filter(color => [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18].includes(color.id));
          case 'Полиэстер двустор. 0,45 мм':
            return fenceAllColors.picket.filter(color => [6,14,16,17].includes(color.id));
          case 'Ecosteel 0,5 мм':
          case 'Ecosteel двустор. 0,5 мм':
            return fenceAllColors.picket.filter(color => [19,20,21,22,23].includes(color.id));
          default:
            return fenceAllColors.picket;
        }
      }

      setColors(getPicketCoatingColor())
    } else {
      const getPailingCoatingColor = () => {
        switch (fenceStore.pailingCoating) {
          case 'Полиэстер 0,4 мм':
            return fenceAllColors.pailing.filter(color => [1,6,8,11,14,15,19,21].includes(color.id));
          case 'Полиэстер 0,45 мм':
            return fenceAllColors.pailing.filter(color => [1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20,21,22,23,24].includes(color.id));
          case 'Norman MP 0,5 мм':
            return fenceAllColors.pailing.filter(color => [1,2,6,8,10,11,14,15,17,19,20,21,22,24,25,26,27].includes(color.id));
          case 'Цинк 0,4 мм':
            return fenceAllColors.pailing.filter(color => color.id === 32);
          case 'Цинк 0,45 мм':
            return fenceAllColors.pailing.filter(color => color.id === 32);
          default:
            return fenceAllColors.pailing;
        }
      }

      setColors(getPailingCoatingColor())
    }


  }, [fenceStore.fenceType, fenceStore.pailingCoating, fenceStore.picketCoating])

  useEffect(() => {
    dispatch('fence/set-fence-color', { fenceColor: colors[0].colorName })
  }, [dispatch, colors])




  return (
    <ImageWrapperStyled>
      <ColorBackgroundStyled color={colors.find(color => color.colorName === fenceStore.fenceColor )?.colorCode} >
        <ImageStyled src={presenter.fenceImage} />
      </ColorBackgroundStyled>

      <ControlsWrapperStyled>
        <SwitchWrapperStyled>Спереди <Switch onChange={presenter.fenceSideHandler} /> Сзади</SwitchWrapperStyled>
        <SelectStyled value={presenter.fenceColor} onChange={presenter.fenceColorHandler}>
          {colors.map((color) => (
            <Option key={color.id} value={color.colorName}><ColorStyled color={color.colorCode} />{color.colorName}</Option>
          ))}
        </SelectStyled>
      </ControlsWrapperStyled>

    </ImageWrapperStyled>
  );
};

const ColorBackgroundStyled = styled.div<{ color: string | undefined }>`
  background-color: ${props => props.color ? props.color : '#000000'};
`;

const ColorStyled = styled.span`
  ${(props) => css`
    padding: 0 8.5px;
    margin-right: 5px;
    border-radius: 50%;
    border: 0.7px solid rgba(0, 0, 0, 0.5);
    background-color: ${props.color};
  `}
`;

const ImageWrapperStyled = styled.div`
  position: relative;
`;

const ControlsWrapperStyled = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    display: flex;
    margin: 16px 0;
    position: relative;
    top: unset;
    bottom: unset;
    left: unset;
    right: unset;
  }
`;

const ImageStyled = styled.img`
  display: flex;
  z-index: 10;
  width: 100%;
  max-height: 482px;
`;

const SwitchWrapperStyled = styled.div`
  position: absolute;
  left: 64px;
  top: 32px;
  display: flex;
  flex-grow: 1;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  line-height: 14px;
  color: ${props => props.theme.colors.white};
  text-shadow: 1px 1px 2px ${props => props.theme.colors.black};
  .ant-switch {
    margin: 0 8px;
  }
  @media screen and ${props => props.theme.media.tablet} {}
  @media screen and ${props => props.theme.media.mobile} {
    justify-content: start;
    position: relative;
    left: unset;
    top: unset;
    float: left;
    width: 50%;
  }
`;

const SelectStyled = styled(Select)`
  position: absolute;
  min-width: 155px;
  right: 60px;
  bottom: 42px;
  @media screen and ${props => props.theme.media.tablet} {
  
  }
  @media screen and ${props => props.theme.media.mobile} {
    position: relative;
    right: unset;
    bottom: unset;
    width: 40%;
  }
`;
